import { createTheme } from './utils';
import logotypeImg from './univermag/logotype.png';

export const theme = (parentTheme) =>
  createTheme(parentTheme, {
    colors: {
      primary: '#ef9b2f',
      alt: '#81bc3d',
    },
    images: {
      logotypeImg,
    },
  });

export default theme;



// WEBPACK FOOTER //
// ./src/themes/jumbotronUnivermag.js